import { ModeToggle } from "@/components/mode-toggle";
import { UserNav } from "@/components/admin-panel/user-nav";
import { SheetMenu } from "@/components/admin-panel/sheet-menu";

interface NavbarProps {
  title: string;
  accountBalance: string;
}

export function Navbar({ title, accountBalance }: NavbarProps) {
  return (
    <header className="sticky  mt-[-23px] top-0 z-10 w-full bg-background/95 shadow backdrop-blur supports-[backdrop-filter]:bg-background/60 dark:shadow-secondary">
      <div className="mx-4 sm:mx-8 flex h-14 items-center">
        <div className="flex items-center space-x-4 lg:space-x-0">
          <SheetMenu />
          <h1 className="font-bold text-sm sm:text-base">{title}</h1>
        </div>
        <div className="flex flex-1 items-center space-x-2 sm:space-x-4 justify-end">
          <span className="text-sm sm:text-base">Solde {accountBalance}</span>
          <ModeToggle />
          <UserNav />
        </div>
      </div>
    </header>
  );
}
